import { EmailOTPResponse, MagicTokenResponse } from 'hooks/useThriveAuth/types'
import callApi from 'utils/callApi'
import { AUTH_GOOGLE_SSO, AuthRoutes } from './routes'

export const resetPassword = (email: string): Promise<string> =>
  callApi<string>({
    baseURL: 'https://' + process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
    endpoint: 'dbconnections/change_password',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: {
      client_id: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
      email: email,
      connection: 'Username-Password-Authentication',
    },
  })

export const loginWithMagicLink = (
  email: string,
  params: { redirectTo?: string }
): Promise<MagicTokenResponse> => {
  return callApi({
    endpoint: AuthRoutes.requestMagicLink(),
    method: 'post',
    data: { email, ...params },
  })
}

export const verifyWithOTP = (
  email: string,
  otp: string
): Promise<JwtResponseDto> => {
  return callApi({
    endpoint: AuthRoutes.verifyOtpEnpoint,
    method: 'post',
    data: { email, otp },
  })
}

export const loginWithOTP = (
  email: string,
  isRetry?: boolean
): Promise<EmailOTPResponse> => {
  return callApi({
    endpoint: AuthRoutes.requestOtpEnpoint,
    method: 'post',
    data: {
      email,
      ...(!!isRetry && { isRetry }),
    },
  })
}

export const loginWithGoogleSSO = (
  jwtToken: string,
  relayState: Record<string, string>
): Promise<string> => {
  return callApi({
    endpoint: AUTH_GOOGLE_SSO,
    method: 'post',
    data: { jwtToken, relayState },
  })
}

export class JwtResponseDto {
  access_token?: string
  expires_in?: number
}

export const authenticateWithMagicLink = (
  token: string,
  dob?: string
): Promise<JwtResponseDto> =>
  callApi<JwtResponseDto>({
    endpoint: AuthRoutes.authenticateWithMagicLink(token, dob),
    method: 'get',
  })

export const verifyTokenExpiration = (token: string): Promise<boolean> =>
  callApi<boolean>({
    endpoint: AuthRoutes.verifyTokenExpirationLink(token),
    method: 'get',
  })
